import React, { useState } from "react";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SaveIcon from "@material-ui/icons/Save";
import { showSnackBar } from "../../../../../../../redux/actions/ui";
import AddNewItem from "../../../../../../components/modals/AddNewItem";
import LessonForm from "../components/LessonForm";
import * as yup from 'yup'
import LessonsService from "../../../../../../../services/LessonsService";

const SignupSchema = yup.object().shape({
  name: yup.string().required(),
  // start_date: yup.date().typeError("Invalid date").nullable(),
  end_date: yup.date().typeError("Invalid date").nullable(),
});

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function EditLessonModal(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(true);
  const { isEditModal } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, setValue, getValues, control } = useForm({
    validateCriteriaMode: "all",
    validationSchema: SignupSchema,
    mode: "onChange",
  });

  const createNewLesson = async data => {    
    setIsLoadingSubmit(true);     
    setIsEditableForm(false);
    try{
      data.start_date = data.end_date;
      if(isEditModal){
        data.id = props.data.id;        
        await LessonsService.updateLesson(props.courseId, data);
      }else{
        await LessonsService.createLesson(props.courseId, data);
      }      
      setIsLoadingSubmit(false);      
      setIsEditableForm(true);
      dispatch(showSnackBar("Successfully edited!"));      
      // We updated the list
      props.updateList();
      props.onClose(false);      
    }catch (error) {
      console.log("Error: ", error);
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
      setIsEditableForm(true);
    }  
  };

  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}           
          onClick={handleSubmit(createNewLesson)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          {isEditModal ? "Save": "Create"}
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} title={isEditModal ? "Update Lesson": "Create new Module"}>
      <LessonForm 
        isEditableForm={isEditableForm} 
        onSubmit={createNewLesson} 
        formConfig={ {register, errors, handleSubmit, setValue, getValues, control} }
        data={isEditModal ? props.data : null}
      />
    </AddNewItem>
  )
}

export default EditLessonModal;